import type { TranslationKey } from "@/types/i18n.types";

/**
 * Il trattamento di un alloggio (`price_tag`) e' salvato come stringa inglese, sia
 * quando lo sceglie il TA nella modale sia quando arriva da RateHawk (vedi
 * `mealToTag`). Il valore resta quello — tradurlo romperebbe i dati gia' scritti e
 * il confronto con le tariffe ETG — ma l'etichetta mostrata passa di qui.
 */

/** Le opzioni offerte nella modale alloggio, nell'ordine in cui vanno rese. */
export const PRICE_TAG_OPTIONS = [
  'Only accommodation',
  'Breakfast Included',
  'Half board',
  'Full board',
  'All inclusive',
] as const;

/** Include anche le varianti che solo RateHawk produce. */
const PRICE_TAG_KEYS: Record<string, string> = {
  'Only accommodation': 'modals.priceTags.onlyAccommodation',
  'Breakfast Included': 'modals.priceTags.breakfastIncluded',
  'Breakfast for One': 'modals.priceTags.breakfastForOne',
  'Lunch Included': 'modals.priceTags.lunchIncluded',
  'Dinner Included': 'modals.priceTags.dinnerIncluded',
  'Half board': 'modals.priceTags.halfBoard',
  'Full board': 'modals.priceTags.fullBoard',
  'All inclusive': 'modals.priceTags.allInclusive',
  'Soft All inclusive': 'modals.priceTags.softAllInclusive',
  'Ultra All inclusive': 'modals.priceTags.ultraAllInclusive',
  'Super All inclusive': 'modals.priceTags.superAllInclusive',
};

/**
 * Chiave i18n dell'etichetta, o `null` per un valore che non conosciamo: in quel
 * caso il chiamante mostra la stringa cosi' com'e' invece di una chiave nuda.
 */
export const priceTagKey = (tag?: string | null): TranslationKey | null =>
  (tag && PRICE_TAG_KEYS[tag] ? (PRICE_TAG_KEYS[tag] as TranslationKey) : null);
